/**
 * Hoffmaster Card Widget Handler
 * Minimal JavaScript for card widget initialization.
 * Hover effects and image zoom are CSS-only.
 * Reserved for future interactive behavior (e.g., tilt effect, lazy load).
 */

class HoffmasterCardHandler extends elementorModules.frontend.handlers.Base {
	getDefaultSettings() {
		return {
			selectors: {
				card: '.hm-card',
			},
		};
	}

	getDefaultElements() {
		const selectors = this.getSettings('selectors');
		return {
			$card: this.$element.find(selectors.card),
		};
	}

	bindEvents() {
		// Reserved for future interactive behavior
		// Examples:
		//   - Tilt effect on mouse move
		//   - Lazy loading images
		//   - Intersection observer animations
		//   - Click tracking
	}
}

jQuery(window).on('elementor/frontend/init', () => {
	elementorFrontend.elementsHandler.attachHandler('hm_card', HoffmasterCardHandler);
});
